import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactSelect from 'react-select';

import { fetch as fetchAssets, isAssetsLoading, getAllAssets } from '../../../Store/assets.js';

import { defaultSortAscending } from '../../AssetList/Columns/sort.js';



/**
 */
class AssetSelect extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.props.fetch();
  }

  sortAssets(assets) {
    var newAssets = Array.from(assets);
    newAssets.sort(defaultSortAscending);

    return newAssets;
  }

  onChange(value) {
    if (this.props.onChange) {
      var selected = [];

      if (value && value.length) {
        for (var i = 0; i < value.length; i++) {
          selected.push(value[i].value);
        }
      }

      this.props.onChange(selected);
    }
  }

  formatOptionLabel(data) {
    return (
      <span dangerouslySetInnerHTML={{ __html: data.label }} />
    );
  }

  formatAssetLabel(asset) {
    return `${asset.title} (${asset.ticker.toUpperCase()})`;
  }

  render() {
    var selectOptions = [];
    var selectProps = {
      isMulti: true,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      placeholder: 'Select assets',
      formatOptionLabel: this.formatOptionLabel,
      onChange: this.onChange
    };

    if (this.props.loading) {
      selectProps.isLoading = true;
    } else {
      var selectValue = [];

      var assets = this.sortAssets(this.props.assets);
      for (var i = 0; i < assets.length; i++) { 
        var asset = assets[i];

        if (this.props.value.indexOf(asset.id) > -1) {
          selectValue.push({ value: asset.id, label: this.formatAssetLabel(asset) });
        }

        selectOptions.push({ value: asset.id, label: this.formatAssetLabel(asset) });
      }

      selectProps.value = selectValue;
    }


    return (
      <div className="my-3">
        <ReactSelect {...selectProps} options={selectOptions} />
      </div>
    );
  }
}


var mapStateToProps = function(state) {
  var assets = getAllAssets(state);
  var loading = isAssetsLoading(state);

  return {
    assets: assets,
    loading: loading
  };
};

var mapDispatchToProps = function(dispatch) {
  return {
    fetch: function() {
      dispatch(fetchAssets());
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(AssetSelect);

